import React from 'react';
import { Link } from 'react-router-dom';
import MetaData from '../layout/MetaData';

const Terms = () => (
  <>
    <MetaData title="Terms and Conditions" />
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <div className="card p-4">
            <div className="card-body">
              <h1 className="mb-4 fw-bold text-center">Terms and Conditions</h1>
              <p className="text-muted text-center mb-4">Please read these terms carefully before using our services.</p>
              <hr />
              <div className="terms-content" style={{ fontSize: '0.9375rem', lineHeight: 1.8 }}>
                <p>Welcome to MBZ Transport! By accessing or using our website, you agree to be bound by the following terms and conditions. Please read them carefully before proceeding.</p>

                <h4 className="mt-4">1. General Terms</h4>
                <p>By using our services, you confirm that you are at least 18 years old or have the consent of a legal guardian. MBZ Transport reserves the right to update or modify these terms at any time without prior notice. Continued use of the website indicates your acceptance of the modified terms.</p>
                <p>MBZ Transport is a vehicle booking service that allows users to request a vehicle via a mobile app, through the web, call center, SMS or email. The MBZ Transport Services constitute a technology platform that enables users to arrange and schedule transportation and/or logistics services with independent third party providers.</p>

                <h4 className="mt-4">2. Service Provider Discretion</h4>
                <p>The Service Provider has sole and complete discretion to accept or reject each of your requests for the Services. If the Service Provider accepts your request, the Application notifies you and provides information regarding the Service Provider — including his/her name, vehicle license number, and customer service rating.</p>

                <h4 className="mt-4">3. Payment and Refund Policy</h4>
                <p>Payments must be completed as per the instructions provided during the booking process. Refund requests will be evaluated based on the input given to customer support by the user.</p>

                <h4 className="mt-4">4. User Conduct</h4>
                <p>Users must not engage in activities that disrupt the functionality of the website, including but not limited to hacking, introducing viruses, or attempting unauthorized access. Abusive, defamatory, or unlawful content or behavior is strictly prohibited.</p>

                <h4 className="mt-4">5. Data Privacy and Cookies</h4>
                <p>MBZ Transport uses cookies to improve your experience. By using the site, you consent to our use of cookies. You may disable cookies through your browser settings; however, this may limit your ability to use certain features.</p>

                <h4 className="mt-4">6. Limitation of Liability</h4>
                <p>MBZ Transport is not liable for any indirect, incidental, or consequential damages arising from the use of our website or services. MBZ Transport does not provide transportation or courier services — we are a technology company.</p>

                <h4 className="mt-4">7. Governing Law</h4>
                <p>These terms are governed by the laws of Pakistan. Any disputes arising will be subject to the exclusive jurisdiction of the courts in Pakistan.</p>

                <h4 className="mt-4">8. Contact Us</h4>
                <p>For any questions regarding these terms, please contact us at <a href="mailto:support@mbztransport.com">support@mbztransport.com</a> or call <a href="tel:+923378233366">0337 8233366</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Terms;